import React from 'react'
import { Container } from 'react-bootstrap'
import Layout from '../../components/layout'
import { PageTitle } from '../../components/PageTitle'

export const InvoiceContainer = ({ children }) => {
  return (
    <Layout useOutlet={false}>
      <PageTitle title="Invoice" description="View and manage your invoice details" />
      <div className="my-5">
        <Container>{children}</Container>
      </div>
    </Layout>
  )
}
